
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Layer_1","data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 400 400"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{attrs:{"d":"M314.18 187.45l-63.08-27.78a17.51 17.51 0 00-7.3-1.66h-10.7a.11.11 0 01-.1-.1V85.3c0-22-15.94-41.59-37.68-43.59A41.67 41.67 0 00150 83.14V218.6a.11.11 0 01-.12.1L119 212.07a32.63 32.63 0 00-28.72 9.31l-17.4 17.56a8.41 8.41 0 000 11.82L152 331.18a32.57 32.57 0 0023.4 9.82h108.73a33 33 0 0032.7-27.78l15.27-90.5a33.28 33.28 0 00-17.92-35.27zm-14.19 30l-15.31 90.5a.11.11 0 01-.1.09h-109a.11.11 0 01-.07 0l-57.16-58.4a1.92 1.92 0 011.78-3.23l51.58 11.06a9.36 9.36 0 0011.29-9.22V83a8.79 8.79 0 017.63-8.27 8.57 8.57 0 019.37 8.64V185.9a.11.11 0 00.1.1h26.54a12.66 12.66 0 015.15 1.09l68.14 30.21a.13.13 0 01.07.11z"}})])
          )
        }
      }
    